// Theme utility functions

// Helper function to convert hex to RGB
const hexToRgb = (hex) => {
  // Remove the # if present
  hex = hex.replace('#', '')

  // Parse the hex values
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  return `${r}, ${g}, ${b}`
}

export const initializeTheme = () => {
  // Get theme colors from localStorage
  // const selected_theme = tenantConfigs.find((config) => config.key === 'selected_theme')?.value

  let selected_theme = localStorage.getItem('selected_theme')
  let themePrimaryColor = localStorage.getItem('theme_primary_color')
  let themeSecondaryColor = localStorage.getItem('theme_secondary_color')

  if (selected_theme === 'Custom') {
    themePrimaryColor = localStorage.getItem('custom_primary_color')
    themeSecondaryColor = localStorage.getItem('custom_secondary_color')
  }

  // Set CSS custom properties for theme colors
  if (themePrimaryColor) {
    document.documentElement.style.setProperty('--theme-primary-color', themePrimaryColor)
    document.documentElement.style.setProperty('--primary-color', themePrimaryColor)
    document.documentElement.style.setProperty('--primary-color-rgb', hexToRgb(themePrimaryColor))
  } else {
    // Use default color if no theme color is set (Vasion theme)
    const defaultPrimaryColor = '#3d2562'
    document.documentElement.style.setProperty('--theme-primary-color', defaultPrimaryColor)
    document.documentElement.style.setProperty('--primary-color', defaultPrimaryColor)
    document.documentElement.style.setProperty('--primary-color-rgb', hexToRgb(defaultPrimaryColor))
  }

  if (themeSecondaryColor) {
    document.documentElement.style.setProperty('--theme-secondary-color', themeSecondaryColor)
    document.documentElement.style.setProperty('--secondary-color', themeSecondaryColor)
    document.documentElement.style.setProperty('--secondary-color-rgb', hexToRgb(themeSecondaryColor))
  } else {
    // Use default color if no theme color is set (Vasion theme)
    const defaultSecondaryColor = '#f5f4f7'
    document.documentElement.style.setProperty('--theme-secondary-color', defaultSecondaryColor)
    document.documentElement.style.setProperty('--secondary-color', defaultSecondaryColor)
    document.documentElement.style.setProperty('--secondary-color-rgb', hexToRgb(defaultSecondaryColor))
  }
}

export const updateThemeColor = (primaryColor, secondaryColor) => {
  // Update localStorage
  if (primaryColor) {
    localStorage.setItem('theme_primary_color', primaryColor)
    document.documentElement.style.setProperty('--theme-primary-color', primaryColor)
    document.documentElement.style.setProperty('--primary-color', primaryColor)
    document.documentElement.style.setProperty('--primary-color-rgb', hexToRgb(primaryColor))
  }

  if (secondaryColor) {
    localStorage.setItem('theme_secondary_color', secondaryColor)
    document.documentElement.style.setProperty('--theme-secondary-color', secondaryColor)
    document.documentElement.style.setProperty('--secondary-color', secondaryColor)
    document.documentElement.style.setProperty('--secondary-color-rgb', hexToRgb(secondaryColor))
  }
}

// Call initializeTheme when the module is imported
initializeTheme()

// Listen for storage changes to update theme
window.addEventListener('storage', (event) => {
  if (event.key === 'theme_primary_color') {
    document.documentElement.style.setProperty('--theme-primary-color', event.newValue || '#3d2562')
    document.documentElement.style.setProperty('--primary-color', event.newValue || '#3d2562')
  }
  if (event.key === 'theme_secondary_color') {
    document.documentElement.style.setProperty('--theme-secondary-color', event.newValue || '#f5f4f7')
    document.documentElement.style.setProperty('--secondary-color', event.newValue || '#f5f4f7')
  }
})
